var _circle, _path, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgVpHouse2 = function SvgVpHouse2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 126 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 63,
    cy: 63.465,
    r: 62.5,
    fill: "#D5EAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.5 63.465a62.502 62.502 0 0 1-62.5 62.5c-34.52 0-62.5-27.983-62.5-62.5A62.412 62.412 0 0 1 26.162 12.97L63 63.675V.965c34.516 0 62.5 27.982 62.5 62.5Z",
    fill: "#1C7CE5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.375,
    cy: 63.84,
    r: 46.875,
    fill: "#F8F8F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.473 42.36v6.056l5.343 5.203v-11.26h-5.343Z",
    fill: "#8CB3DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.033 41.722v-2.11a.648.648 0 0 0-.647-.646h-6.497a.648.648 0 0 0-.647.646v2.11c0 .356.29.647.647.647h6.497a.654.654 0 0 0 .647-.647Z",
    fill: "#8CB3DC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.234 43.466 46.537 59.712v23.86h33.394v-23.86L63.234 43.466Z",
    fill: "#AEDAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.493 62.14c0-.571.235-1.115.638-1.509l14.878-14.465-2.775-2.7-16.697 16.246v23.86h3.956V62.14ZM73.473 42.36v6.056l5.343 5.203v-11.26h-5.343Z",
    fill: "#8CB3DC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M76.566 48.828a1.397 1.397 0 0 1-.422-1.003v-5.466h-2.671v6.057l5.343 5.203v-2.597l-2.25-2.194Z",
    fill: "#1C7CE5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m84.365 58.728-19.734-19.2a2.016 2.016 0 0 0-2.794 0l-19.735 19.2a2.009 2.009 0 0 0-.037 2.831 2 2 0 0 0 2.831.038l18.066-17.578c.15-.15.394-.15.553 0l18.066 17.568c.796.77 2.062.75 2.83-.037.76-.788.741-2.053-.046-2.822Z",
    fill: "#FFE6A1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.962 44.019a.42.42 0 0 1 .244-.113l1.762-1.706a1.979 1.979 0 0 1 1.903-.497l-2.24-2.175a2.016 2.016 0 0 0-2.794 0l-19.735 19.2a2.009 2.009 0 0 0-.037 2.831 2 2 0 0 0 2.831.038l18.066-17.578Z",
    fill: "#FFD553"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.033 41.722v-2.11a.648.648 0 0 0-.647-.646h-6.497a.648.648 0 0 0-.647.646v2.11c0 .356.29.647.647.647h6.497a.654.654 0 0 0 .647-.647Z",
    fill: "#8CB3DC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M74.708 41.722v-2.11c0-.356.29-.646.647-.646h-2.466a.648.648 0 0 0-.647.646v2.11c0 .356.29.647.647.647h2.466a.654.654 0 0 1-.647-.647Z",
    fill: "#1C7CE5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M64.865 65.58V79.11c0 .3.244.544.544.544h10.125c.3 0 .544-.244.544-.544V65.581H64.865Z",
    fill: "#014A99"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M71.192 65.675c0-.038 0-.066-.01-.094h-1.434c0 .028-.009.066-.009.094v6.262h-1.247v1.453h1.247v6.263h1.453V73.39h4.875v-1.453h-4.875v-6.262Z",
    fill: "#AEDAFF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M69.037 79.643H65.41a.544.544 0 0 1-.544-.543V65.58h3.628V79.11c0 .29.244.534.544.534Z",
    fill: "#1C7CE5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M64.865 71.937h3.628v1.453h-3.628v-1.453Z",
    fill: "#BBDAF2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M75.524 62.16H65.4c-.3 0-.543.215-.543.477v2.616h11.203v-2.616c.009-.262-.235-.478-.535-.478Z",
    fill: "#1C7CE5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M69.037 62.16c-.3 0-.544.243-.544.543v2.981-.094h-3.628v-2.878c0-.3.244-.544.544-.544h3.628v-.009Z",
    fill: "#014A99"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M61.602 62.703V83.57H50.398V62.704c0-.3.244-.544.544-.544h10.125c.29 0 .535.244.535.544Z",
    fill: "#E87F56"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M54.57 62.16c-.3 0-.543.243-.543.543V83.57h-3.629V62.704c0-.3.244-.544.544-.544h3.628Z",
    fill: "#014A99"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.23 73.681a1.022 1.022 0 1 0 0-2.044 1.022 1.022 0 0 0 0 2.044Z",
    fill: "#DFEBFA"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M80.634 83.28h-34.8a.694.694 0 0 0-.693.704v2.288c0 .384.309.693.693.693h34.81c.384 0 .703-.31.703-.703v-2.287a.715.715 0 0 0-.713-.694Z",
    fill: "#99EDBA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.556 86.263v-2.288a.7.7 0 0 1 .694-.703h-4.416a.694.694 0 0 0-.693.703v2.288a.7.7 0 0 0 .693.703h4.416a.694.694 0 0 1-.694-.703Z",
    fill: "#57C975"
  })));
};
export default SvgVpHouse2;